export type ProjectAccessCapability = 'loading' | 'enabled' | 'disabled' | 'unavailable'

export function projectAccessCapability(value: unknown): Exclude<ProjectAccessCapability, 'loading'> {
  if (!value || typeof value !== 'object') return 'unavailable'
  const health = value as { ok?: unknown; projectAccess?: { normalizedWriters?: unknown; enforcement?: unknown } }
  if (health.ok !== true || health.projectAccess?.normalizedWriters !== true) return 'unavailable'
  if (health.projectAccess.enforcement === 'enabled') return 'enabled'
  if (health.projectAccess.enforcement === 'disabled') return 'disabled'
  return 'unavailable'
}
